/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable import/prefer-default-export */
import { AxiosError } from 'axios';

export const throwLoaderError = <T = any>(e: AxiosError<T>): never => {
	throw e.response?.status && e.response?.status > 500
		? e.response.statusText || e.message
		: e.response?.data || e;
};
